import React from 'react';
import { Popconfirm, Button, Pagination, Row, Col } from 'antd';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { SERVER_IP } from 'assets/Config';
import TableComponent from 'components/table-component';
import { deleteApi } from 'redux/sagas/deleteApiSaga';
import { useI18n } from 'hooks/useI18n';

const EventListPresentational = ({
	filteredData,
	column,
	tableLoading,
	rowSelection,
	selectedRowKeys,
	handleAddEvent,
	currentPage,
	pageSize,
	initialPageSizeOptions,
	initialPageSize,
	handleTableChange,
	setSearchKey,
	getStartingValue,
	getEndingValue,
	eventAddModal,
	setEventAddModal,
	refreshList,
	editEvent,
	handleClose,
}) => {
	const dispatch = useDispatch();
	const { t } = useI18n();
	return (
		<>
			<Row>
				<Col span={24} style={{ padding: 20 }}>
					<TableComponent
						loading={tableLoading}
						className="custom-table"
						style={{ width: '100%' }}
						columns={column}
						bordered
						rowKey={(record) => record.id}
						dataSource={filteredData}
						rowSelection={rowSelection}
						title={() => (
							<Row style={{ justifyContent: 'space-between' }}>
								<Col span={8}>
									<Row gutter={[10, 10]}>
										<Col xl={24}>
											<Row gutter={[10, 10]} align="middle">
												<Col>
													{/* <Input
														placeholder="Search"
														suffix={<AiOutlineSearch />}
														style={{ height: '30px' }}
														onChange={({ target: { value } }) => setSearchKey(value)}
													/> */}
												</Col>
												{selectedRowKeys?.length === 1 ? (
													<Col>
														<Popconfirm
															title={t('ui.questions.delete_event')}
															okText={t('common.delete')}
															cancelText={t('common.no')}
															onConfirm={() => {
																let url = `${SERVER_IP}api/events/${selectedRowKeys?.[0]}`;
																dispatch(deleteApi('DELETE_EVENT', url));
																refreshList();
															}}>
															<div style={{ textDecoration: 'underline', color: 'red', cursor: 'pointer' }}>{t('common.delete')}</div>
														</Popconfirm>
													</Col>
												) : null}
											</Row>
										</Col>
									</Row>
								</Col>
								<Col>
								<Link to="/events/new">
									<Button type="primary">
										{t('events.add_event')}
									</Button>
								</Link>
								</Col>
							</Row>
						)}
						pagination={{
							current: currentPage,
							pageSize: pageSize,
							position: ['none', 'none'],
						}}
						footer={() => (
							<Row justify="space-between">
								<Col span={12}>
									{!!filteredData?.length && t('events.footer.showing_range', { start: getStartingValue(), end: getEndingValue(), total: filteredData?.length })}
								</Col>
								<Col span={12}>
									<div style={{ textAlign: 'right' }}>
										<Pagination
											pageSizeOptions={initialPageSizeOptions}
											defaultPageSize={initialPageSize}
											showSizeChanger={true}
											total={filteredData?.length}
											onChange={handleTableChange}
											responsive
										/>
									</div>
								</Col>
							</Row>
						)}
					/>
				</Col>
			</Row>
			{/* <AddEvent {...{ eventAddModal, setEventAddModal, refreshList, editEvent, handleClose }} /> */}
		</>
	);
};

export default EventListPresentational;
